import { IOfficeMenuItem } from '../models/office-nav.model';

export const INQUIRIES_MENU_ITEM: IOfficeMenuItem = { name: 'Inquiries', formList: [], ModuleShortName: Symbol('Inquiries').toString() };
